<app-sidebar [isOpen]="open" (close)="sidebarCancel(true)" [bigSize]="false">
  @if (open) {
    <div class="sidebar-container astral-sidebar-shell">
      <div class="form-body astral-sidebar-content">
        <div class="sidebar-header astral-sidebar-header">
          <h4>{{ 'ROOM.REORDER_ROOMS' | translate }}</h4>
        </div>
        <div class="sidebar-content">
          @if (reorderedItems.length > 0) {
            <ul
              class="column-list"
              cdkDropList
              [cdkDropListDisabled]="false"
              [cdkDropListData]="reorderedItems"
              (cdkDropListDropped)="drop($event)">
              @for (item of reorderedItems; track item) {
                <li
                  cdkDrag
                  cdkDragLockAxis="y"
                  cdkDragBoundary=".column-list"
                  class="list-item"
                  [ngClass]="{ 'drag-list': true }"
                  >
                  <div class="room-item"><i [ngClass]="getIcons(item)"></i>{{ item.caption | translate }}</div>
                  <div class="move" cdkDragHandle></div>
                </li>
              }
            </ul>
          }
        </div>
      </div>
      <div class="form-footer astral-sidebar-footer">
        <astral-button variant="primary" type="button" labelKey="ACCEPT_BTN" (click)="sidebarSave()"></astral-button>
        <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="sidebarCancel(true)"></astral-button>
      </div>
    </div>
  }
</app-sidebar>
